import ContractMeterData from "@/http/data/contract-meter-data";

export default class MeterState {
    contractMeters: ContractMeterData[] = [];
    isInitialized = false;
    selectedMeterContractId: null|string = null;
    forceUpload = false;
}